"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCookie = exports.openDocument = exports.isEmptyWithBool = exports.isEmpty = exports.isBoolean = exports.getRandomInt = exports.getDocumentUrl = exports.getDataByStatus = exports.getCookie = exports.getBrowserPlatform = exports.getAssetsSum = exports.getAddressByID = exports.generatePassword = exports.fromURLtoBase64 = exports.formatToCash = exports.formatStringLength = exports.formatNumberValue = exports.formatCurrency = exports.formatAddress = exports.findUserByID = exports.findJobByID = exports.findItemById = exports.findDebtById = exports.findCashflowById = exports.findByID = exports.findAssetByID = exports.filterCanvas = exports.filterArrayByKey = exports.dataURItoBlob = exports.cutValue = exports.covertUtcDate = exports.convertBoolean = exports.clearObject = exports.checkPassStrength = exports.checkBrowser = exports.capitalizeFirstLetter = exports.camelize = exports.bodyScrollclassFunc = exports.arrayStringify = void 0;
exports.roundFifty = roundFifty;
exports.roundFiveThousand = roundFiveThousand;
exports.roundHundred = roundHundred;
exports.roundPrice = void 0;
exports.roundThousand = roundThousand;
exports.userNameVal = exports.transifexTranslate = exports.transformInternalLink = exports.toBase64 = exports.telephoneFormat = exports.statusColorClass = exports.setCookie = exports.scorePassword = exports.sanitizeText = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));
var cheerio = _interopRequireWildcard(require("cheerio"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var _lodash = require("lodash");
var _filter = _interopRequireDefault(require("lodash/filter"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _libphonenumberJs = require("libphonenumber-js");
var _CountryCodePhone = require("../constants/CountryCodePhone");
var _ConfigHelper = require("../configuration/ConfigHelper");
var _EnvConstans = require("../configuration/EnvConstans");
var _SettingsWebpack = _interopRequireDefault(require("../configuration/SettingsWebpack"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/* global Transifex */

const cookies = new _universalCookie.default();
const bodyScrollclassFunc = () => {
  const multiEl = document.getElementsByClassName('multiStepSlides')[0];
  const singleEl = document.getElementsByClassName('singleStep')[0];
  const contentEl = document.getElementsByClassName('content')[0];
  const hubDasEl = document.getElementsByClassName('hubDasContent')[0];
  const thirdLevelEl = document.getElementsByClassName('thirdLevel')[0];
  let scrollClass;
  if (multiEl && singleEl) {
    if (getComputedStyle(multiEl, null).getPropertyValue('overflow-y') === 'auto') {
      scrollClass = multiEl;
    } else if (getComputedStyle(singleEl, null).getPropertyValue('overflow-y') === 'auto') {
      scrollClass = singleEl;
    }
  } else if (contentEl) {
    scrollClass = contentEl;
  } else if (hubDasEl) {
    if (thirdLevelEl && getComputedStyle(thirdLevelEl, null).getPropertyValue('overflow-y') === 'auto') {
      scrollClass = thirdLevelEl;
    } else {
      scrollClass = hubDasEl;
    }
  }
  return scrollClass;
};
exports.bodyScrollclassFunc = bodyScrollclassFunc;
const isEmpty = val => {
  let empty = true;
  if (!val && val !== 0) {
    empty = true;
  }
  if (typeof val === 'number') {
    empty = false;
  }
  if (typeof val === 'string') {
    empty = !val.trim();
  }
  if (typeof val === 'object' && val) {
    empty = !Object.keys(val).length;
  }
  if (typeof val === 'boolean' && (val === true || val === false)) {
    empty = false;
  }
  if (Array.isArray(val)) {
    empty = !val.length;
  }
  return empty;
};
exports.isEmpty = isEmpty;
const isEmptyWithBool = val => {
  let empty = true;
  if (!val && val !== 0) {
    empty = true;
  }
  if (typeof val === 'number') {
    empty = false;
  }
  if (typeof val === 'string') {
    empty = !val.trim();
  }
  if (typeof val === 'object' && val) {
    empty = !Object.keys(val).length;
  }
  if (typeof val === 'boolean') {
    empty = false;
  }
  if (Array.isArray(val)) {
    empty = !val.length;
  }
  return empty;
};
exports.isEmptyWithBool = isEmptyWithBool;
const isBoolean = value => typeof value === 'boolean';
exports.isBoolean = isBoolean;
const formatStringLength = (text = '', length = -1) => text && text.length > length ? `${text.slice(0, length)}...` : text;
exports.formatStringLength = formatStringLength;
const filterCanvas = canvas => {
  const ctx = canvas.getContext('2d');
  if (ctx) {
    const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const {
      data
    } = imgData;
    for (let i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 255) {
        data[i] = 255;
        data[i + 1] = 255;
        data[i + 2] = 255;
        data[i + 3] = 255;
      }
    }
    ctx.putImageData(imgData, 0, 0);
  }
  return canvas;
};
exports.filterCanvas = filterCanvas;
const dataURItoBlob = dataURI => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString;
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1]);
  } else {
    byteString = unescape(dataURI.split(',')[1]);
  }
  // separate out the mime component
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ia], {
    type: mimeString
  });
};
exports.dataURItoBlob = dataURItoBlob;
const getRandomInt = (min, max) => Math.floor(Math.random() * (max - (min + 1))) + min;
exports.getRandomInt = getRandomInt;
const arrayStringify = (array = [], separator = ',') => array.join(separator);
exports.arrayStringify = arrayStringify;
const covertUtcDate = dateStr => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('safari') !== -1 ? new Date(dateStr.replace(/-/g, '/').replace(/T/g, ' ')) : new Date(dateStr);
};
exports.covertUtcDate = covertUtcDate;
const clearObject = obj => {
  const result = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] === true || obj[key] === false) {
      result[key] = obj[key];
    }
  });
  return result;
};
exports.clearObject = clearObject;
const findUserByID = (state, array, id) => (0, _get.default)(state, array, []).find(result => result.profile_uuid === id);
exports.findUserByID = findUserByID;
const findByID = (array, id, name) => {
  let user;
  Object.keys(array).map(item => {
    const nestedArray = array[item];
    if (array[item] && (0, _isArray.default)(array[item])) {
      array[item].map(subitem => {
        if (subitem[name] === id) {
          user = subitem;
        }
        return null;
      });
    } else if (array[item] !== null) {
      if (nestedArray[name] === id) {
        user = array[item];
      }
    }
    return null;
  });
  return user;
};
exports.findByID = findByID;
const findJobByID = (state, array, id) => (0, _get.default)(state, array, []).find(result => result.plan_user_job_uuid === id);
exports.findJobByID = findJobByID;
const findAssetByID = (state, array, id) => (0, _get.default)(state, array, []).find(result => result.plan_asset_uuid === id);
exports.findAssetByID = findAssetByID;
const findDebtById = (state, array, id) => (0, _get.default)(state, array, []).find(result => result.plan_debt_uuid === id);
exports.findDebtById = findDebtById;
const getAddressByID = (state, array, id) => (0, _get.default)(state, array, []).find(address => address.address_uuid === (0, _get.default)(state, id, null));
exports.getAddressByID = getAddressByID;
const findCashflowById = (state, array, id) => (0, _get.default)(state, array, []).find(cashflow => (0, _get.default)(cashflow, 'profile_uuid', null) === id);
exports.findCashflowById = findCashflowById;
const findItemById = (array, key, id) => array.find(item => (0, _get.default)(item, key, null) === id);
exports.findItemById = findItemById;
const formatToCash = value => value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,').replace('.00', '');
exports.formatToCash = formatToCash;
const getAssetsSum = (assets, inNumberFormat) => {
  if (assets && !isEmpty(assets)) {
    let sum = 0;
    Object.values(assets).map(assetsValue => {
      const assetsCurrentValue = (0, _get.default)(assetsValue, 'current_value', null);
      sum += assetsCurrentValue;
      (0, _get.default)(assetsValue, 'regular_contributions', []).map(asset => {
        const assetAmount = (0, _get.default)(asset, 'amount', null);
        const assetValueType = (0, _get.default)(asset, 'value_type', null);
        const assetFrequency = (0, _get.default)(asset, 'frequency', null);
        const frequencyMultiplier = assetFrequency === 'per_month' ? 12 : 1;
        const valueTypeMultiplier = assetValueType === 'F' ? 1 : assetsCurrentValue / 100;
        if (assetAmount) sum += assetAmount * frequencyMultiplier * valueTypeMultiplier;
        return null;
      });
      return null;
    });
    if (inNumberFormat) {
      return sum;
    }
    return `£${formatToCash(sum)}`;
  }
  return inNumberFormat ? 0 : '£0';
};
exports.getAssetsSum = getAssetsSum;
const filterArrayByKey = (array = [], arrayItemKey = '', filterKeys = null) => {
  if (Array.isArray(array) && array.length > 0 && !(0, _lodash.isNull)(filterKeys)) {
    if ((0, _isArray.default)(filterKeys)) {
      return (0, _filter.default)(array, item => filterKeys.includes(item[arrayItemKey]));
    }
    if ((0, _isString.default)(filterKeys)) {
      return (0, _filter.default)(array, item => item[arrayItemKey] === filterKeys);
    }
    return null;
  }
  return null;
};
exports.filterArrayByKey = filterArrayByKey;
const formatCurrency = value => {
  const newValue = (0, _lodash.isNaN)(parseFloat(value)) ? '' : parseFloat(value);
  return newValue.toLocaleString('en');
};
exports.formatCurrency = formatCurrency;
const getBrowserPlatform = act => {
  if (typeof navigator !== 'undefined') {
    let device = navigator.platform;
    let mobile = false;
    if (navigator.userAgent.match(/BlackBerry/i)) {
      mobile = true;
      device = 'blackberry';
    } else if (navigator.userAgent.match(/Android/i)) {
      mobile = true;
      device = 'android';
    } else if (navigator.userAgent.match(/iPhone|iPad|iPod/i) || navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform)) {
      mobile = true;
      device = 'ios';
    } else if (navigator.userAgent.match(/Opera Mini/i)) {
      mobile = true;
      device = 'operaMini';
    } else if (navigator.userAgent.match(/IEMobile/i)) {
      mobile = true;
      device = 'ieMobile';
    }
    if (act === 'full') {
      return {
        className: mobile ? `mobile ${device}` : `desktop ${device}`,
        mobile,
        device
      };
    }
    return mobile ? `mobile ${device}` : `desktop ${device}`;
  }
  return '';
};
exports.getBrowserPlatform = getBrowserPlatform;
const telephoneFormat = (value, isReturnObj = false, noPrefix = false, asUrl = false, asString = false, options = {}) => {
  let objNum = value;
  if ((0, _lodash.isObject)(value) && value && Object.keys(value).length === 0 || !value) return '';
  if (!(0, _lodash.has)(value, 'number')) {
    const val = value ? value.toString().replace(/ /g, '') : '';
    if (val.charAt(0) === '+') {
      let countryCode = _CountryCodePhone.phonecode.find(tel => tel.dial_code === val.substring(0, 3));
      if (countryCode) {
        const prefix = val.substring(0, 3);
        const number = val.substring(3);
        const defVal = number.match(/.{1,3}/g);
        if (defVal) return `${prefix} ${defVal.join(' ')}`;
        return prefix;
      }
      countryCode = _CountryCodePhone.phonecode.find(tel => tel.dial_code === val.substring(0, 4));
      if (countryCode) {
        const prefix = val.substring(0, 4);
        const number = val.substring(4);
        objNum = {
          prefix,
          number
        };
      } else {
        objNum = {
          prefix: null,
          number: value
        };
      }
    } else {
      objNum = {
        prefix: null,
        number: value
      };
    }
  }
  const realNum = typeof objNum === 'object' && objNum !== null && (0, _lodash.has)(objNum, 'number') ? `${objNum.prefix || ''}${objNum.number}` : `${typeof objNum === 'string' && objNum.replace(/ /g, '')}`;
  const phoneNumber = (0, _libphonenumberJs.parsePhoneNumberFromString)(realNum);
  if (isReturnObj) {
    return objNum;
  }
  if (asString) return realNum;
  if ((0, _get.default)(options, 'validate', false) && phoneNumber) {
    if (typeof phoneNumber === 'undefined') return 'Please enter a valid phone number';
    if (!phoneNumber.isValid() && typeof objNum === 'object' && objNum !== null && !objNum.prefix) return 'Please select your country dial code';
    if (!phoneNumber.isValid()) return 'Please enter a valid phone number';
    return true;
  }
  if (asUrl) return `tel:${realNum}`;
  if (typeof objNum === 'object' && objNum !== null && !isEmptyWithBool((0, _get.default)(objNum, 'number', true))) {
    if ((0, _get.default)(objNum, 'prefix', null) === '+41' && (0, _get.default)(objNum, 'number', null).toString()[0] === '0' && realNum && !noPrefix && !asUrl) {
      let realNumSplitted = (0, _get.default)(objNum, 'number', '');
      realNumSplitted = [(0, _get.default)(objNum, 'prefix', ''), realNumSplitted.substring(0, 3), realNumSplitted.substring(3, 6), realNumSplitted.substring(6, 8), realNumSplitted.substring(8, 10)];
      return realNumSplitted ? realNumSplitted.join(' ') : '';
    }
    if (typeof phoneNumber !== 'undefined' && phoneNumber && !noPrefix) return phoneNumber.formatInternational();
    if (typeof phoneNumber !== 'undefined' && phoneNumber && noPrefix) return phoneNumber.formatNational();
    if (typeof phoneNumber !== 'undefined' && phoneNumber && asUrl) return phoneNumber.getURI();
    let realNumSplitted = realNum ? realNum.match(/.{1,3}/g) : null;
    if ((0, _get.default)(objNum, 'prefix', null) === '+41' && (0, _get.default)(objNum, 'number', null).toString()[0] === 0 && realNum) {
      realNumSplitted = realNum.toString();
      realNumSplitted = [realNumSplitted.substring(0, 2), realNumSplitted.substring(2, 5), realNumSplitted.substring(5, 6), realNumSplitted.substring(6, 8)];
    }
    return realNumSplitted ? realNumSplitted.join(' ') : '';
  }
  return '';
};
exports.telephoneFormat = telephoneFormat;
const scorePassword = pass => {
  let score = 0;
  if (!pass) return score;
  // award every unique letter until 5 repetitions
  const letters = {};
  for (let i = 0; i < pass.length; i += 1) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }
  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  };
  let variationCount = 0;
  Object.keys(variations).forEach(check => {
    variationCount += variations[check] === true ? 1 : 0;
  });
  score += (variationCount - 1) * 10;
  if (pass.length > 5) return score;
  return 0;
};
exports.scorePassword = scorePassword;
const checkPassStrength = pass => {
  const score = scorePassword(pass);
  const strengthLabel = ['Bad', 'Weak', 'Good', 'Strong'];
  let value = 1;
  if (score > 80) value = 4;else if (score > 60) value = 3;else if (score > 40) value = 2;else if (score > 20) value = 1;
  return {
    value,
    label: strengthLabel[value - 1]
  };
};
exports.checkPassStrength = checkPassStrength;
const generatePassword = () => {
  const length = 12;
  const charset = 'abcdefghijklmnopqrstuvwxyz0123456789!@£$%^&*()_+ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let retVal = '';
  for (let i = 1, n = charset.length; i < length; i += 1) {
    retVal += charset.charAt(Math.floor(Math.random() * n));
  }
  return retVal;
};
exports.generatePassword = generatePassword;
function roundHundred(value) {
  return Math.round(value / 100) * 100;
}
function roundThousand(value) {
  return Math.round(value / 1000) * 1000;
}
function roundFiveThousand(value) {
  return Math.round(value / 5000) * 5000;
}
function roundFifty(value) {
  return Math.round(value / 50) * 50;
}
const roundPrice = (value, countryCode) => {
  let localString = 'de-CH';
  if (countryCode.toLowerCase() === 'pt') localString = 'it-IT';
  const val = !(0, _lodash.isNaN)(+value) && value ? +value.toFixed(0) : 0;
  return val.toLocaleString(localString);
};
exports.roundPrice = roundPrice;
const formatNumberValue = (val, defCurrency) => {
  let currency = 'CHF';
  if (defCurrency) currency = defCurrency;
  let localString = 'de-CH';
  if (currency === 'EUR') localString = 'it-IT';
  const value = (0, _lodash.isNumber)(+val) ? +val : 0;
  return value.toLocaleString(localString);
};
exports.formatNumberValue = formatNumberValue;
const formatAddress = (address, type) => {
  if (!address) {
    return null;
  }
  const street = [address.name, address.streetNumber].filter(i => !!i).join(' ');
  const city = [address.zip, address.city].filter(i => !!i).join(' ');
  const country = address.country || null;
  if (type === 'full') return [street, city, country].filter(i => !!i).join(', ');
  return [street, city].filter(i => !!i).join(', ');
};
exports.formatAddress = formatAddress;
const userNameVal = (first, last, full) => {
  let name;
  if (first && last) {
    name = `${first} ${last}`;
  } else if (full) {
    name = `${full}`;
  } else {
    name = 'No Name';
  }
  return name;
};
exports.userNameVal = userNameVal;
const transifexTranslate = text => {
  let translateString = text;
  // @ts-ignore
  if (typeof Transifex !== 'undefined' && Transifex.live) {
    // @ts-ignore
    translateString = Transifex.live.translateText(text);
  }
  return translateString;
};
exports.transifexTranslate = transifexTranslate;
const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve({
    file: reader.result,
    name: (0, _get.default)(file, 'name', '')
  });
  reader.onerror = error => reject(error);
});
exports.toBase64 = toBase64;
const camelize = str => {
  if (str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => index === 0 ? word.toUpperCase() : word.toUpperCase()).replace(/\s+/g, '').replace(/-/g, '');
  }
  return '';
};
exports.camelize = camelize;
const convertBoolean = str => {
  switch (str.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true;
    case 'false':
    case 'no':
    case '0':
    case null:
      return false;
    default:
      return Boolean(str);
  }
};
exports.convertBoolean = convertBoolean;
const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);
exports.capitalizeFirstLetter = capitalizeFirstLetter;
const setCookie = (key, val) => {
  const host = (0, _get.default)(window, 'location.host', '').split('.');
  const localhost = host[0].match(/localhost/gi);
  const localip = host[0].match(/0/gi);
  let domain;
  if (localhost) {
    domain = 'localhost';
  } else if (localip) {
    domain = '0.0.0.0';
  } else {
    const curDomain = (0, _get.default)(document, 'location.hostname', '').split('.')[(0, _get.default)(document, 'location.hostname', '').split('.').length - 1];
    domain = `.brixel.${curDomain}`;
  }
  const options = {
    domain,
    path: '/',
    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    sameSite: true
  };
  cookies.set(key, val, options);
};
exports.setCookie = setCookie;
const getCookie = key => {
  return cookies.get(key);
};
exports.getCookie = getCookie;
const removeCookie = key => {
  const host = (0, _get.default)(window, 'location.host', '').split('.');
  const localhost = host[0].match(/localhost/gi);
  const localip = host[0].match(/0/gi);
  let domain;
  if (localhost) {
    domain = 'localhost';
  } else if (localip) {
    domain = '0.0.0.0';
  } else {
    const curDomain = (0, _get.default)(document, 'location.hostname', '').split('.')[(0, _get.default)(document, 'location.hostname', '').split('.').length - 1];
    domain = `.brixel.${curDomain}`;
  }
  const options = {
    domain,
    path: '/',
    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    sameSite: true
  };
  cookies.remove(key, options);
};
exports.removeCookie = removeCookie;
const checkBrowser = () => {
  let rv = -1; // Return value assumes failure.
  if (navigator.appName === 'Microsoft Internet Explorer') {
    const ua = navigator.userAgent;
    const re = new RegExp('MSIE ([0-9]{1,}[\\.0-9]{0,})');
    if (re.exec(ua) !== null) {
      rv = parseFloat(RegExp.$1);
    }
  } else if (navigator.appName === 'Netscape') {
    /// in IE 11 the navigator.appVersion says 'trident'
    /// in Edge the navigator.appVersion does not say trident
    if (navigator.appVersion.indexOf('Trident') === -1) rv = -1;else rv = 11;
  }
  return rv;
};
exports.checkBrowser = checkBrowser;
const cutValue = val => {
  let formatVal = val;
  if (val > 10000) {
    formatVal = val / 10000;
    formatVal = formatVal % 1 !== 0 ? formatVal.toFixed(2) : formatVal;
    formatVal = `${formatVal}K`;
  }
  if (val > 100000) {
    formatVal = val / 1000000;
    formatVal = formatVal % 1 !== 0 ? formatVal.toFixed(2) : formatVal;
    formatVal = `${formatVal}M`;
  }
  return formatVal;
};
exports.cutValue = cutValue;
const sanitizeText = (stringText, opt = {
  preserveDoctypes: false
}) => {
  const doctypeRegex = /^\s*<!DOCTYPE .*?>/i;
  const opts = Object.assign({}, opt);
  let htmlContent = stringText;
  // Basic input validation:
  if (htmlContent == undefined || htmlContent == null || typeof htmlContent != 'string') {
    return '';
  }
  // Sanitize the HTML first:
  let doctypes;
  if (opts.preserveDoctypes) {
    doctypes = htmlContent.match(doctypeRegex);
  }
  htmlContent = (0, _sanitizeHtml.default)(htmlContent, {
    allowedTags: ['address', 'article', 'aside', 'footer', 'header', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup', 'main', 'nav', 'section', 'blockquote', 'dd', 'div', 'dl', 'dt', 'figcaption', 'figure', 'hr', 'li', 'main', 'ol', 'p', 'pre', 'ul', 'a', 'abbr', 'b', 'bdi', 'bdo', 'br', 'cite', 'code', 'data', 'dfn', 'em', 'i', 'kbd', 'mark', 'q', 'rb', 'rp', 'rt', 'rtc', 'ruby', 's', 'samp', 'small', 'span', 'strong', 'sub', 'sup', 'time', 'u', 'var', 'wbr', 'caption', 'col', 'colgroup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'tr'],
    allowedAttributes: {
      a: ['href', 'name', 'target'],
      // We don't currently allow img itself by default, but
      // these attributes would make sense if we did.
      img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
      selfClosing: ['img', 'br', 'hr', 'area', 'base', 'basefont', 'input', 'link', 'meta']
    },
    allowedSchemesByTag: {
      img: ['http', 'https', 'data', 'cid']
    },
    allowedSchemes: ['http', 'https', 'ftp', 'mailto', 'tel']
  });
  // Preserve doctype
  if (doctypes && doctypes.length) {
    htmlContent = doctypes[0] + htmlContent;
  }
  const $ = cheerio.load(htmlContent);
  // Remove all script tags:
  $('script').remove();
  // Remove all attributes which contain javascipt:
  const domElements = $('*');
  let domElement;
  for (let i = 0; i < domElements.length; i++) {
    domElement = domElements[i];
    const attribs = Object.keys(domElement.attribs);
    domElement = $(domElement);
    for (let j = 0; j < attribs.length; j++) {
      const attrib = attribs[j];
      // Remove all JS event attributes which start with on like onclick
      if (/^on/i.test(attrib) && domElement) {
        domElement.removeAttr(attrib);
      }
      // Remove href attributes which contain JS
      if (/href/i.test(attrib) && /^\s*javascript/i.test(domElement.attr(attrib))) {
        domElement.removeAttr(attrib);
      }
    }
  }
  // Remove 'action' attributes from 'form' tags:
  const formElements = $('form');
  for (let i = 0; i < formElements.length; i++) {
    domElement.removeAttr('action');
  }
  // Remove link elements with 'as' attribute equalling to 'script'
  $('link[as="script"]').remove();
  return $.html();
};
// Generate Universal color class based on property status
exports.sanitizeText = sanitizeText;
const statusColorClass = status => {
  switch (status) {
    case 'on-sale':
      {
        return 'txtGreen400';
      }
    case 'on-request':
      {
        return 'txtText700';
      }
    case 'sold':
      {
        return 'txtRed400';
      }
    case 'reserved':
      {
        return 'txtYellow400';
      }
    case 'to-rent':
      {
        return 'txtBlue400';
      }
    default:
  }
};
exports.statusColorClass = statusColorClass;
const getDocumentUrl = (id, baseByData = null) => {
  let baseData = baseByData;
  if (!baseByData) {
    const curUrl = typeof window !== 'undefined' ? window.location.host : 'dev';
    const env = (0, _ConfigHelper.GetEnviroment)(curUrl).env === 'LOCAL' ? 'dev' : (0, _ConfigHelper.GetEnviroment)(curUrl).env;
    switch (env.toLowerCase()) {
      case 'local':
      case 'dev':
        baseData = _EnvConstans.EndpointEnv.dev;
        break;
      case 'staging':
        baseData = _EnvConstans.EndpointEnv.staging;
        break;
      default:
        baseData = _EnvConstans.EndpointEnv.production;
        break;
    }
  }
  const token = cookies.get('brixelToken');
  if (baseData) {
    return fetch(`${baseData.apiRoot}/document/${id}/loadUrl`, {
      headers: {
        'x-brixel-token': token
      }
    }).then(response => response.json()).then(res => {
      return res;
    }).catch(function (error) {
      return error;
    });
  }
  return Promise.resolve({
    error: 'No base data provided'
  });
};
exports.getDocumentUrl = getDocumentUrl;
const openDocument = (id, baseByData = null) => {
  let baseData = baseByData;
  if (!baseByData) {
    const curUrl = typeof window !== 'undefined' ? window.location.host : 'dev';
    const env = (0, _ConfigHelper.GetEnviroment)(curUrl).env === 'LOCAL' ? 'dev' : (0, _ConfigHelper.GetEnviroment)(curUrl).env;
    switch (env.toLowerCase()) {
      case 'local':
      case 'dev':
        baseData = _EnvConstans.EndpointEnv.dev;
        break;
      case 'staging':
        baseData = _EnvConstans.EndpointEnv.staging;
        break;
      default:
        baseData = _EnvConstans.EndpointEnv.production;
        break;
    }
  }
  const token = cookies.get('brixelToken');
  if (baseData) {
    fetch(`${baseData.apiPath}/document/${id}`, {
      headers: {
        'x-brixel-token': token
      }
    }).then(function (response) {
      if (response.ok && typeof document !== 'undefined') {
        return response.blob().then(function (myBlob) {
          const fileURL = URL.createObjectURL(myBlob);
          const a = document.createElement('a');
          a.href = fileURL;
          a.target = '_blank';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
      } else {
        return response.json().then(function (jsonError) {
          // eslint-disable-next-line no-console
          console.error(jsonError);
        });
      }
    }).catch(function (error) {
      // eslint-disable-next-line no-console
      console.log('There has been a problem with your fetch operation: ', error.message);
    });
  }
};
exports.openDocument = openDocument;
const getDataByStatus = dataStatus => {
  let data = {
    bg: '',
    color: 'txtYellow400',
    colorName: 'yellow',
    icon: 'clock',
    iconAlt: '',
    status: 'pending',
    text: 'Pending'
  };
  const sellerStatus = dataStatus?.sellerStatus;
  const buyerStatus = dataStatus?.buyerStatus;
  const status = dataStatus?.status;
  if (dataStatus?.visit?.date < new Date().valueOf() && sellerStatus === 'accepted' && buyerStatus === 'accepted') {
    data = {
      bg: 'bgBlue100',
      color: 'txtBlue400',
      colorName: 'blue',
      icon: 'check',
      iconAlt: '',
      status: 'visited',
      text: 'Visited'
    };
  } else if (sellerStatus === 'rejected' || buyerStatus === 'rejected' || status === 'rejected') {
    data = {
      bg: 'bgRed50',
      color: 'txtRed400',
      colorName: 'red',
      icon: 'close-small',
      iconAlt: '',
      status: 'cancelled',
      text: 'Cancelled'
    };
  } else if (sellerStatus === 'accepted' && buyerStatus === 'accepted' || status === 'accepted') {
    data = {
      bg: 'bgGreen100',
      color: 'txtGreen400',
      colorName: 'green',
      icon: 'check-thin',
      iconAlt: 'check-small',
      status: 'accepted',
      text: 'Confirmed'
    };
  } else if (status === 'pending') {
    data = {
      bg: 'bgYellow100',
      color: 'txtYellow400',
      colorName: 'yellow',
      icon: 'clock',
      iconAlt: '',
      status: 'pending',
      text: 'Pending'
    };
  }
  return data;
};
exports.getDataByStatus = getDataByStatus;
const fromURLtoBase64 = async (img, callback) => {
  const degrees = 90;
  const url = await fetch(img).then(response => response.blob()).then(blob => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      if (typeof base64data === 'string') {
        const newImg = new Image();
        newImg.src = base64data;
        newImg.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = newImg.height;
          canvas.height = newImg.width;
          const ctx = canvas.getContext('2d');
          if (ctx) {
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(degrees * Math.PI / 180);
            ctx.drawImage(newImg, newImg.width / -2, newImg.height / -2);
          }
          callback(canvas.toDataURL('image/jpeg'));
          return canvas.toDataURL('image/jpeg');
        };
      }
    };
  });
  return url;
};
exports.fromURLtoBase64 = fromURLtoBase64;
const transformInternalLink = (url, {
  activeSingleProperty
}) => {
  const getEnv = (0, _ConfigHelper.GetEnviroment)(window.location.host);
  const configData = (0, _SettingsWebpack.default)(getEnv.env);
  const mapObj = {
    DOMAIN_HUB: configData.hubUrl,
    'DOMAIN.HUB': configData.hubUrl,
    'domain.hub': configData.hubUrl,
    PAGE_ID: activeSingleProperty?.id || '',
    'http://': '',
    'https://': ''
  };
  if (!url.includes('PAGE_ID') && !url.includes('DOMAIN_HUB')) {
    return url;
  } else {
    const internalLink = url.replace(/PAGE_ID|DOMAIN_HUB|DOMAIN.HUB|domain.hub|http:\/\/|https:\/\//gi, function (matched) {
      return mapObj[matched];
    });
    return internalLink;
  }
};
exports.transformInternalLink = transformInternalLink;